import React, { Component, Fragment } from 'react'

export default class Slideshow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentImage: 0
    }
  }

  render() {
    const { activeHouse } = this.props
    const { currentImage } = this.state
    const imageBig = `https://s3.eu-west-2.amazonaws.com/bizon-assets/Houses/${activeHouse.images[currentImage].path}`

    return (
      <Fragment>
        <div className="cover"
          style={{
            backgroundImage: `url(${imageBig})`
          }} />

        <div className="picker">
          {activeHouse.images.map((x, i) =>
            <div
              key={`house-picker-item-${i}`}
              onClick={() => this.setState({ currentImage: i })}
              className={`picker-item ${this.state.currentImage === i ?
                'picker-item-active' :
                'picker-item-inactive'}`
              }
              style={{
                backgroundImage: `url(${(`https://s3.eu-west-2.amazonaws.com/bizon-assets/Houses/${x.path.replace('full', 'thumbs/small')}`)})`
              }} />
          )}
        </div>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Houses/slideshow.js